import React, {Fragment} from "react";
import PropTypes from "prop-types";
import moment from "moment";
import AppConfig from "../../config/AppConfig";
import {AppIconThumbnail} from "../../components/BaseComponents/AppIconThumbnail";
import {PluralString} from "../../helpers/UIUtility";
import ModalPortalHOC from "../../components/BaseComponents/ModalPortalHOC";
import {ServiceBookResumePage} from "../NextBooks/ServiceBook/ServiceBookResume/ServiceBookResumePage";

export function ServiceWaitingListItem({item}) {
    let servicesLabel = 'Prenotazione #' + item.id_prenotazione;
    if (item.book.services) {
        servicesLabel = item.book.services[0];
        if (item.book.services.length > 2) {
            servicesLabel += ` e altri ${item.book.services.length - 1} servizi`;
        } else if (item.book.services.length > 1) {
            servicesLabel += ` e un'altro servizio`;
        }
    }

    const [modalOpen, setModalOpen] = React.useState(false);
    const handleModalDismiss = _ => setModalOpen(false);
    const handleModalOpen = _ => setModalOpen(true);

    return (
        <React.Fragment>
            <li className={"list-group-item shadow-sm border-bottom"} onClick={handleModalOpen}>
                <div className={"d-flex small align-items-center mb-1"}>
                    <AppIconThumbnail
                        src={`${AppConfig.webServerUrl}/api/negozio/${item.negozio.id_negozio}/logoIcon/100`}
                        size={"25px"}/>&nbsp;
                    {item.negozio.nome}
                </div>
                <div><b>{servicesLabel}</b></div>
                <div className={"text-muted"}>
                    In attesa di un posto per <b>{moment(item.date).format('ddd DD MMMM YYYY')}</b> tra
                    le <b>{item.start_time}</b> e <b>{item.end_time}</b>
                </div>
            </li>
            <ModalPortalHOC>
                {
                    modalOpen && <ServiceBookResumePage
                        idPrenotazione={item.id_prenotazione}
                        onDismiss={handleModalDismiss}
                        showOpenApp={true}
                    />
                }
            </ModalPortalHOC>
        </React.Fragment>
    );
}

ServiceWaitingListItem.propTypes = {
    item: PropTypes.shape({
        id_prenotazione: PropTypes.number,
        date: PropTypes.string,
        start_time: PropTypes.string,
        end_time: PropTypes.string,
        created_at: PropTypes.string,
        book: PropTypes.shape({
            date_ymd: PropTypes.string,
            time: PropTypes.string,
            status: PropTypes.string,
            services: PropTypes.arrayOf(PropTypes.string),
        }),
        negozio: PropTypes.shape({
            id_negozio: PropTypes.number,
            nome: PropTypes.string,
        }),
    }).isRequired,
};
